import { gql } from '@apollo/client';

const fetchAvailableStatesForCountries = gql`
  query fetchAvailableStatesForCountries($isoCode: String) {
    availableStatesForCountry(isoCode: $isoCode) {
      totalCount
      nodes {
        isoCode
        name
      }
    }
    availableTaxLabels(isoCode: $isoCode) {
      region
      taxIdLabels {
        description
        displayName
        type
        metadata {
          type
          labels {
            default
            label
            vatStatus
          }
        }
      }
    }
  }
`;

export default fetchAvailableStatesForCountries;
